import { render, staticRenderFns } from "./OwnCustomerSessions.vue?vue&type=template&id=e603fbc0&scoped=true"
import script from "./OwnCustomerSessions.vue?vue&type=script&lang=ts"
export * from "./OwnCustomerSessions.vue?vue&type=script&lang=ts"
import style0 from "./OwnCustomerSessions.vue?vue&type=style&index=0&id=e603fbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e603fbc0",
  null
  
)

export default component.exports